import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { useBot } from '../context/BotContext';
import { TABS } from '../constants/tabs';
import BurnerWallet from './BurnerWallet';

const { FiCpu } = FiIcons;

export default function Sidebar({ activeTab, setActiveTab }) {
  const { balance, positions, settings } = useBot();

  const positionsValue = positions.reduce(
    (acc, p) => acc + (p.buyPrice > 0 ? p.amountSol * (p.currentPrice / p.buyPrice) : 0), 0
  );
  const totalEquity = balance + positionsValue;

  return (
    <aside className="hidden lg:flex w-56 flex-shrink-0 flex-col bg-[#1c1c1d] border-r border-[#2c2c2e] sticky top-0 h-screen">
      {/* Logo */}
      <div className="flex items-center gap-3 px-5 py-4 border-b border-[#2c2c2e] flex-shrink-0">
        <div className="w-9 h-9 rounded-xl bg-blue-500/20 border border-blue-500/30 flex items-center justify-center text-blue-400 flex-shrink-0">
          <SafeIcon icon={FiCpu} className="text-lg" />
        </div>
        <div>
          <p className="text-white font-bold text-sm leading-tight">Solana Bot</p>
          <p className={`text-[10px] font-semibold ${settings.tradingMode === 'live' ? 'text-green-400' : 'text-gray-500'}`}>
            {settings.tradingMode === 'live' ? '⚡ Live Trading' : 'Paper Trading'}
          </p>
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 px-3 py-4 flex flex-col gap-1 overflow-y-auto">
        {TABS.map(tab => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium transition-colors text-left ${
              activeTab === tab.id
                ? 'bg-blue-500/15 text-blue-400 border border-blue-500/25'
                : 'text-gray-400 hover:text-white hover:bg-[#2c2c2e] border border-transparent'
            }`}
          >
            <SafeIcon icon={tab.icon} className="text-[18px] flex-shrink-0" />
            {tab.label}
          </button>
        ))}
      </nav>

      {/* Equity card (paper mode only) + Wallet */}
      <div className="px-3 pb-4 pt-3 border-t border-[#2c2c2e] flex-shrink-0 space-y-2">
        {settings.tradingMode !== 'live' && (
          <div className="bg-[#0a0a0b] border border-[#2c2c2e] rounded-xl p-3">
            <p className="text-[10px] text-gray-500 uppercase tracking-wider mb-1">Total Equity</p>
            <p className="text-green-400 font-mono font-bold text-base leading-tight">
              {totalEquity.toFixed(2)} <span className="text-xs font-normal text-green-500/70">SOL</span>
            </p>
            <p className="text-[10px] text-gray-500 font-mono mt-1">
              Avail: <span className="text-white">{balance.toFixed(2)}</span>
            </p>
          </div>
        )}
        {settings.tradingMode === 'live' && <BurnerWallet />}
      </div>
    </aside>
  );
}
